/* unplugin-vue-components disabled */import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Popup from "vux/src/components/popup/index.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Checklist from "vux/src/components/checklist/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import Checker from "vux/src/components/checker/checker.vue"; // this line is trasformed by vux-loader
import CheckerItem from "vux/src/components/checker/checker-item.vue"; // this line is trasformed by vux-loader
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import SearchBar from '@/components/SearchBar';
import { getLinkPerson } from '@/api';
import FlowList from '@/components/ScrollerList/FlowList';
export default {
  name: 'SelectCustomer',
  components: {
    FlowList: FlowList,
    SearchBar: SearchBar,
    Popup: Popup,
    ViewBox: ViewBox,
    Checklist: Checklist,
    XButton: XButton,
    Checker: Checker,
    CheckerItem: CheckerItem,
    Cell: Cell
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showMask: {
      type: Boolean,
      default: true
    },
    list: Array
  },
  data: function data() {
    return {
      currValue: this.value,
      tagList: [],
      selected: null,
      keyword: ''
    };
  },
  computed: {
    customTagList: function customTagList() {
      return this.list.map(function (item) {
        return {
          value: item.id,
          key: item.name
        };
      });
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    change: function change(val) {
      this.selected = val[0];
    },
    submit: function submit() {
      this.$emit('on-success', this.selected);
      this.currValue = false;
    }
  }
};